import { ChartSeries } from "models/model";

export const checkSeriesDataXDateLessThanMax = (max: string, series: ChartSeries[]) => {
  if (!max) {
    return undefined;
  }
  const maxDate = new Date(max);
  return series?.some((data) =>
    data?.x?.some((value) => {
      const date = new Date(value);
      return date > maxDate;
    })
  )
    ? max
    : undefined;
};
